// Portuguese Spanish translation file for the i18n module

import { TranslateDto } from "../translate.dto";

export const pt: TranslateDto = {
  // Not found Page
  Not_found_page: "404: Página Não Encontrada",
  //Global
  Go_back: "Voltar ao início",
  // Topbar
  Slogan: "Os únicos óculos 100% personalizáveis",
  // PutPostCode
  Error_PERMISSION_DENIED: "O usuário negou permissão para geolocalização.",
  Error_POSITION_UNAVAILABLE:
    "As informações de localização não estão disponíveis.",
  Error_TIMEOUT: "O tempo de solicitação expirou.",
  Error_UNKNOWN_ERROR: "Um erro desconhecido ocorreu.",
  Error_default: "Um erro desconhecido ocorreu.",
  Search_your_optic: "Encontre a óptica mais próxima",
  Description_for_search_optic:
    "Introduza a sua morada e nós procuramos as ópticas mais perto de si ",
  Alert: "Parece que há algo errado",
  Placeholder_search_optic: "Escreva a sua morada ou CP",
  Can_I_Have_Your_Ubication: "Posso aceder à sua localização?",
  Description_We_Need_Ubication:
    "Para encontrar a óptica mais próxima de si, deve permitir-nos aceder à sua localização",
  Confirm: "Sim, claro!",
  Denaied: "Não, obrigado",
  Cant_Accesses_Your_Ubication:
    "Desculpe, não consigo aceder à sua localização",
  Description_Cant_Accesses_Your_Ubication:
    "Parece que você negou o acesso à sua localização. Para encontrar a óptica mais próxima de si, deverá escrever a sua morada ou código postal no campo acima",
  Accept: "Aceitar",
  Search_GPS: "Procurando GPS...",
  Use_My_Location: "Usar a minha localização atual",
  No_Selection_Location: "Você não selecionou nenhum endereço",
  Search: "Procurar",
  Ofert1: "Aproveita os 15% de desconto + presente surpresa por tempo limitado",
  // Ubication
  Go_to_the_list: "De volta à lista",
  This_is_your_optics: "Estas são as ópticas mais próximas:",
  Description_We_Need_Ubication2:
    "Escreva o seu endereço na barra de pesquisa acima para ver a óptica mais próxima",
  Not_Found_Optics: "Ops...! Não há ópticas perto de si",
  Form_to_contact: "Também pode entrar em contato connosco através",
  Distance: " Km de distância",
  Ask_date: "SOLICITE UMA DATA",
  // CardOptic
  Optic_nearest: "Esta é a sua óptica mais próxima",
  Of_distance: " de distância",
  See_map: "Ver mapa",
  // Schedule
  Ofert2: "Marque uma visita e ganhe 15% de desconto e um exame visual grátis!",
  PostCode_banner_promo:
    "Marque uma visita e ganhe um desconto e um exame visual grátis!",
  Choose_optic: "Óptica escolhida:",
  Direction: "Direção:",
  Selected_day: "Selecione um dia:",
  Schedule_subtitle: "Clique na hora do dia em que deseja experimentar os seus FLiPO sem compromisso e com exame visual gratuito",
  Choose_hour: "Escolha um horário para ser atendido:",
  Load_more_days: "Carregar mais dias",
  No_search_schedules: "Ops...! Nenhuma data disponível",
  Change_optic: "Mudar óptica",
  See_more: "Ver mais",
  Try_another_week: "Você também pode tentar outra semana",
  // Hours Container
  No_schedule: "Sem datas restantes",
  // Client Data
  Form_title: "Preencha o seus dados para agendar horário",
  Receive_ofert: "Você receberá a sua oferta por e-mail e WhatsApp",
  Your_choose_optic: "A sua óptica escolhida:",
  Your_choose_date: "A sua data escolhida:",
  Name: "Nome",
  Subname: "Apelido",
  Phone: "Telefone",
  Email: "E-mail",
  Incorrect_field: "Campo errado *",
  Next: "Próximo",
  // Confirmation
  Error_create_appointment: "Ocorreu um erro ao criar a visita.",
  Error_update_appointment: "Ocorreu um erro ao atualizar a visita.",
  Error_active_appointment_title: "Já tem uma consulta ativa",
  Error_active_appointment_desc:
    "Não pode reservar outra consulta enquanto tiver uma consulta ativa pendente. Se precisar de alterá-la, contacte a sua óptica ou edite-a a partir do email que recebeu ao criá-la.",
  Edit_your_data: "Edite os seus dados para alterar a data",
  Confirm_for_reserve: "Consulta confirmada com sucesso",
  changeMyData: "Mudar os meus dados",
  Change_my_optic: "Mudar a minha óptica",
  Change_my_date: "Mudar a minha data",
  Your_data: "Os seus dados de contacto:",
  Confirm_appointment: "Confirmar visita",
  Edit_my_data: "Editar os meus dados",
  // Resume
  Greetings: "Olá",
  Of: "de",
  Await_you: "no dia estará à sua espera",
  At: "Às",
  If_put: "Se usa lentes de contacto",
  No_24h: "não as coloque por 24 horas",
  Pre_exam: "pré-exame",
  Is_easy: "É muito fácil chegar a:",
  Benefit_appointment_title: "Durante a consulta:",
  Benefit_appointment_1: "Nós avaliamos gratuitamente",
  Benefit_appointment_2:
    "Pode experimentar uma ampla seleção de cores e acessórios",
  Benefit_appointment_3:
    "Irá ver qual dos nossos modelos mais se adapta ao seu rosto",
  Benefit_appointment_4:
    "Pode ver com o seu oftalmologista quais clipes precisa",
  Free: "Tudo de graça!",
  Remember:
    "Lembre-se que com um horário agendado, não terá que fazer fila, é também, estando presente",
  Promotion: "poderá desfrutar de 15% de desconto e do presente surpresa",
  No_assist:
    "Caso não possa comparecer ou tenha alguma dúvida, entre em contato connosco via",
  Or: "ou",
  Start: "Começar",
  Until_the: "Até o",
  // Landing Page
  Landing_header: "DESCUBRA A NOSSA COLEÇÃO DE ACESSÓRIOS",
  Landing_hero_banner_title_1: "MARQUE CONSULTA E",
  Landing_hero_banner_title_2: "OBTENHA OS SEUS FLiPO",
  Landing_hero_banner_subtitle: "EXAME GRATUITO E EM MINUTOS",
  Landing_hero_title_1: "O SEU EXAME VISUAL, ",
  Landing_hero_title_2: "GRATUITO",
  Landing_hero_title_3: "E EM MINUTOS",
  Landing_form_subtitle: "Está a um clique de descobrir as",
  Landing_form_subtitle_highlight: "óculos modulares que mudam consigo",
  Landing_form_name_label: "Nome*",
  Landing_form_phone_label: "Telefone*",
  Landing_form_lastname_label: "Apelido*",
  Landing_form_email_label: "Email*",
  Landing_form_postcode_label: "Código postal*",
  Landing_form_postcode_placeholder: "Procure o seu endereço ou código postal",
  Landing_form_button: "RESERVE A SUA CONSULTA GRATUITA",
  Landing_form_no_thanks: "Não quero graduar os meus óculos",
  Landing_form_disclaimer: "*Os seus dados serão utilizados apenas para coordenar a consulta. Nunca partilharemos informações.",
  Landing_glasses_title_1: "ADAPTE OS SEUS FLiPO",
  Landing_glasses_title_2: "A QUALQUER MOMENTO DO DIA",
  Landing_glasses_solar_title: "Proteção Solar",
  Landing_glasses_solar_desc: "Lente polarizada US10 com UV400 para reduzir o brilho. Proteja-se da exposição solar.",
  Landing_glasses_dreamred_title: "DreamRed",
  Landing_glasses_dreamred_desc: "Lente de descanso. As lentes vermelhas bloqueiam 100% da luz azul e 60% da luz verde, favorecendo a produção natural de luz.",
  Landing_glasses_screen_title: "Proteção de Ecrã",
  Landing_glasses_screen_desc: "Reduz reflexos, mantém-o claro e melhora o contraste entre ecrã e ambiente. Aumenta contra a luz azul.",
  Landing_glasses_night_title: "Condução noturna",
  Landing_glasses_night_desc: "Lente polarizada V75 Enhanced com UV400 que permite visão sem reflexos, reduzindo o brilho.",
  Landing_color_banner_title: "ADICIONE COR E ESTILO AOS SEUS ÓCULOS",
  Landing_color_banner_text: "Mude clips e hastes para que os seus óculos combinem com o seu outfit, humor ou ocasião.",
  Landing_color_banner_button: "MARQUE A SUA CONSULTA",
  Landing_final_banner_title_1: "E você,",
  Landing_final_banner_title_2: "que FLiPO escolhe?",
  Landing_newsletter_title: "Subscreva a nossa Newsletter",
  Landing_newsletter_subtitle: "Fique a par de todas as nossas ofertas e novidades",
  Landing_newsletter_email_placeholder: "Endereço de email",
  Landing_newsletter_checkbox: "Li e aceito a Política de Privacidade e os Termos e Condições",
  Landing_newsletter_country_label: "País/região",
  Landing_social_title: "Siga-nos nas nossas redes",
  Landing_footer_plan: "Plano de subscrição",
  Landing_footer_faqs: "FAQs",
  Landing_footer_shipping: "Envios e Devoluções",
  Landing_footer_payment: "Método de Pagamento",
  Landing_footer_gift: "Cartões Presente",
  Landing_footer_contact: "Contacto",
  Landing_footer_jobs: "Trabalhe connosco",
  Landing_copyright: "© Copyright 2025. FLiPO.",
  Landing_copyright_rights: "Todos os direitos reservados.",
  Landing_privacy: "Política de privacidade e cookies",
  Landing_shipping_policy: "Política de envio",
  Landing_terms: "Termos e condições",
  Landing_contact_info: "Informações de contacto",
  Landing_legal_notice: "Aviso legal",
  // Loading & Error screens
  Loading_searching_optic: "Procurando a sua óptica...",
  Loading_moment: "Isso levará apenas um momento",
  Creating_appointment: "Estamos a criar a sua consulta...",
  Error_optic_not_found: "Óptica não encontrada",
  Error_optic_not_found_desc: "Não conseguimos encontrar a óptica com o código fornecido. Por favor, verifique o link ou procure uma óptica próxima.",
  Error_network: "Erro de conexão",
  Error_network_desc: "Não foi possível conectar ao servidor. Por favor, verifique a sua conexão com a internet e tente novamente.",
  Error_unknown: "Algo correu mal",
  Error_unknown_desc: "Ocorreu um erro inesperado. Por favor, tente novamente ou procure uma óptica próxima.",
  Error_search_nearby: "Procurar óptica próxima",
  Error_retry: "Tentar novamente",
  Error_go_home: "Ir para o início",
  // FAQs
  Question_1: "De que são feitos os óculos FLiPO?",
  Answer_1:
    "Todos os nossos produtos estão fabricados com um material pioneiro pela sua flexibilidade e resistência, conhecido como ULTEM. Para mais informação podes consultar a ficha técnica de cada modelo de óculos.",
  Question_2: "Como funcionam os clips e as hastes?",
  Answer_2:
    "Os clips e as hastes funcionam graças a um sistema magnético que faz com que estes se possam aplicar de uma maneira fácil e segura sem o medo de que se vão soltar.",
  Question_3: "Que diferença há entre o clip funcional e o de desenho?",
  Answer_3:
    "O clip funcional reúne a ajuda visual das lentes graduadas e através das diferentes funcionalidades transforma os teus óculos, protege da luz azul, do sol e dos diferentes raios que possam afetar a tua vista. Enquanto que, o clip de desenho muda a aparência da parte frontal da armação juntamento com a troca da haste, conseguindo mudar o estilo dos óculos por completo.",
  Question_4: "Quando estarão prontos os meus FLiPO monofocais?",
  Answer_4:
    "Os teus óculos estarão graduados em 7-10 dias laborais. E depois, é só disfrutar!",
  Question_5: "Quando estarão prontos os meus FLiPO progressivos?",
  Answer_5:
    "Os teus óculos estarão graduados em 7-10 dias laborais. A espera vale a pena!",
};
